import { gql } from "@apollo/client";
import { DEDUCTION_FRAGMENT } from "./deductionFragment";

const GET_DEDUCTION_BY_REMITTANCE_ITEM_ID = gql`
  ${DEDUCTION_FRAGMENT}
  query GetDeductionByRemittanceItem($params: GetDeductionsByRemittanceItemIDParams!) {
    deductions(params: $params) {
      count
      items {
        ...DeductionFields
      }
    }
  }
`;

export default GET_DEDUCTION_BY_REMITTANCE_ITEM_ID;
